import { NEXT_STEP, SET_ACTIVE_STEP } from "../actions/action-types";

export const activeStepReducer = (state = { step: 0, subStep: 0 }, action) => {
  if (action.type === SET_ACTIVE_STEP) {
    return {
      ...state,
      ...action.activeStep
    };
  }

  if (action.type === NEXT_STEP) {
    const activeStep = state;
    const steps = action.steps;
    const isIncrementSubStep = () => {
      return !!(
        steps[activeStep.step].children &&
        activeStep.subStep < steps[activeStep.step].children.length - 1
      );
    };
    if (isIncrementSubStep()) {
      activeStep.subStep += 1;
    } else {
      activeStep.step += 1;
      activeStep.subStep = 0;
    }
    return {
      ...state,
      ...action.activeStep
    };
  }

  return state;
};
